import React, { FC, PropsWithChildren } from "react";
// router (incl. auto-generated route tree)
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "../../routeTree.gen";

// Create a new router instance
export const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  // eslint-disable-next-line no-unused-vars
  interface Register {
    router: typeof router;
  }
}

const TanStackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? (): null => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );

export const TanstackRouterSetup: FC<PropsWithChildren> = () => {
  return (
    <>
      <RouterProvider router={router} />
      <React.Suspense>
        <TanStackRouterDevtools router={router} />
      </React.Suspense>
    </>
  );
};
